// react
import React from "react";

// components
import Slider from "./Slider";

// utils
import Clamp from "../../utils/Clamp";

import PropTypes from "../../lib/prop-types";

import Icon from "../Icon";
// styles
import css from "./Pagination.module.scss";

/**
 * @deprecated Use the Pagination component from the py-components package instead.
 */
export default class Pagination extends React.Component {
	static propTypes = {
		showSlider: PropTypes.bool,
		optionsCount: PropTypes.number,
		containerSize: PropTypes.number,
		buttonSize: PropTypes.number,
		pageCount: PropTypes.number,
		currentPage: PropTypes.number,
		onClick: PropTypes.func.isRequired,
	};

	static defaultProps = {
		optionsCount: 5,
		containerSize: 30,
		buttonSize: 24,

		pageCount: 0,
		currentPage: 0,

		showSlider: false,
	};

	state = {
		sliderPercent: 0,
		isDragging: false,
		betaMode: false,
	};

	static getDerivedStateFromProps(nextProps, currentState) {
		if (nextProps.value !== undefined && !currentState.isDragging) {
			return {
				sliderPercent: nextProps.currentPage / nextProps.pageCount,
			};
		}

		return null;
	}

	getStartPage = (currentPage) => {
		const { optionsCount, pageCount } = this.props;

		let startPage = currentPage;

		if (currentPage <= 4) {
			startPage = 1;
		} else if (pageCount - currentPage <= 2) {
			startPage = pageCount + 1 - optionsCount;
		} else {
			startPage = currentPage - 2;
		}

		return startPage;
	};

	handleDragStart = () => {
		this.setState({ isDragging: true });
	};

	handleDragEnd = () => {
		const { pageCount } = this.props;
		const { sliderPercent } = this.state;

		this.setState({ isDragging: false });

		const activePage = Clamp(Math.round(sliderPercent * pageCount), 1, pageCount);
		this.props.onClick(activePage);
	};

	handleSliderChange = (value) => {
		this.setState({ sliderPercent: value });
	};

	handleClick = (page) => {
		let nextPage = page;

		switch (nextPage) {
			case "previous": {
				nextPage = this.props.currentPage - 1;
				break;
			}

			case "next": {
				nextPage = this.props.currentPage + 1;
				break;
			}

			default:
				break;
		}

		this.props.onClick(Clamp(nextPage, 1, this.props.pageCount));
	};

	turnOnBeta = () => {
		this.setState({ betaMode: !this.state.betaMode });
	};

	render() {
		const { optionsCount } = this.props;
		const { sliderPercent, isDragging } = this.state;

		const { containerSize, buttonSize, currentPage, pageCount } = this.props;

		if (currentPage === 0 || pageCount <= 1) {
			return <div />;
		}

		// hide slider if pageCount is less than 5
		const showSlider = !!((this.props.showSlider || this.state.betaMode) && pageCount > 5);

		// determine current page
		const activePage = isDragging ? Clamp(Math.round(sliderPercent * pageCount), 1, pageCount) : currentPage;

		// calculate the options count
		const pageButtonCount = optionsCount > pageCount ? pageCount : optionsCount;

		// pages
		const pagesList = [];
		const startPage = this.getStartPage(activePage);

		for (let i = 0; i < pageButtonCount; i += 1) {
			const pageNumber = startPage + i;

			pagesList.push(
				<div
					key={`page-${pageNumber}`}
					onClick={() => {
						this.handleClick(pageNumber);
					}}
					className={`${css.pageNumber} ${activePage === pageNumber ? css.isActive : css.nonactive}`}
					style={{
						lineHeight: `${buttonSize}px`,
						height: buttonSize,
					}}
				>
					{pageNumber}
				</div>
			);
		}

		return (
			<div className={css.cpPagination}>
				<div style={{ textAlign: "center" }}>
					{activePage > 1 ? (
						<div
							onClick={() => {
								this.handleClick("previous");
							}}
							className={`${css.incrementButton} ${css.previous}`}
							style={{ height: containerSize, width: 65 }}
						>
							<div
								className={css.iconEl}
								style={{
									top: 6,
									left: 5,
									height: 18,
									width: 18,
								}}
							>
								<Icon type="material" size={18} name="chevron_left" />
							</div>
							<div className={css.label} style={{ lineHeight: `${containerSize}px` }}>
								Back
							</div>
						</div>
					) : (
						<div
							ref={(n) => {
								this.betaSwitch = n;
							}}
							onDoubleClick={this.turnOnBeta}
							style={{
								display: "inline-block",
								verticalAlign: "middle",
								width: 65,
								height: 30,
							}}
						/>
					)}

					<div className={css.pageNumberContainer}>{pagesList}</div>

					{activePage < pageCount ? (
						<div
							onClick={() => {
								this.handleClick("next");
							}}
							className={`${css.incrementButton} ${css.next}`}
							style={{ height: containerSize, width: 65 }}
						>
							<div className={css.label} style={{ lineHeight: `${containerSize}px` }}>
								Next
							</div>
							<div
								className={css.iconEl}
								style={{
									top: 6,
									right: 5,
									height: 18,
									width: 18,
								}}
							>
								<Icon type="material" size={18} name="chevron_right" />
							</div>
						</div>
					) : (
						<div
							style={{
								display: "inline-block",
								verticalAlign: "middle",
								width: 65,
								height: 30,
							}}
						/>
					)}
				</div>

				<div>
					{showSlider ? (
						<Slider
							onDragStart={this.handleDragStart}
							onDragEnd={this.handleDragEnd}
							onChange={this.handleSliderChange}
							width={200}
							value={sliderPercent}
						/>
					) : (
						""
					)}
				</div>
			</div>
		);
	}
}
